import React from 'react';
import PropTypes from 'prop-types';

// CONSTANTS
import { ROUTE_WATCH_NEXT } from '@/constants/routes';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

// COMPONENTS
import RouterLink from '@/components/Link';

// STYLES
import { BannerWatchNextStyled } from './styles';

const whatToWatchImg = getS3ImageUrl('/watch-next/what-to-watch-banner.png');

function BannerWatchNext({ btnProps, ...props }) {
  return (
    <BannerWatchNextStyled
      btnProps={{
        component: RouterLink,
        to: ROUTE_WATCH_NEXT,
        ...btnProps,
      }}
      content={<img src={whatToWatchImg} alt="#" />}
      {...props}
    />
  );
}

BannerWatchNext.defaultProps = {
  btnProps: {},
};

BannerWatchNext.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  btnText: PropTypes.string.isRequired,
  btnProps: PropTypes.object,
  content: PropTypes.node,
};

export default BannerWatchNext;
